import { render, staticRenderFns } from "./epms1010.vue?vue&type=template&id=dfb48348&scoped=true"
import script from "./epms1010.vue?vue&type=script&lang=js"
export * from "./epms1010.vue?vue&type=script&lang=js"
import style0 from "./epms1010.vue?vue&type=style&index=0&id=dfb48348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb48348",
  null
  
)

export default component.exports